import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { usePageTransition, TextReveal } from '../PageTransition';

const ReservationCTA = () => {
  const { t } = useTranslation();
  const { navigateWithTransition } = usePageTransition();
  
  return (
    <section className="relative py-24 md:py-32 bg-[#2F2F2F]">
      <div className="max-w-[1000px] mx-auto px-6 md:px-12 text-center">
        <TextReveal><p className="text-[#C97A2B] text-xs tracking-[0.3em] uppercase mb-4">{t('reservation.subtitle')}</p></TextReveal>
        <TextReveal delay={0.1}>
          <h2 className="text-4xl md:text-5xl lg:text-6xl text-white mb-6" style={{ fontFamily: "'DM Serif Display', Georgia, serif" }}>
            {t('reservation.title').split(' ').map((word, i) => 
              word === 'Table' || word === 'pöytäsi' || word === 'bord' ? <span key={i}><span className="italic">{word}</span></span> : <span key={i}>{word} </span>
            )}
          </h2>
        </TextReveal>
        <TextReveal delay={0.2}><p className="text-white/60 font-light max-w-lg mx-auto mb-10">{t('reservation.description')}</p></TextReveal>
        
        <motion.div className="flex flex-col sm:flex-row gap-4 justify-center" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3 }}>
          <motion.button onClick={() => navigateWithTransition('/combine-tables')}
            className="bg-[#C97A2B] text-black px-10 py-5 text-xs tracking-[0.15em] uppercase font-semibold hover:bg-white transition-colors duration-500"
            whileHover={{ scale: 1.02 }} data-cursor-hover data-testid="cta-reserve-btn">{t('reservation.reserveNow')}</motion.button>
          <motion.a href="tel:+358403779200"
            className="border border-white/30 text-white px-10 py-5 text-xs tracking-[0.15em] uppercase hover:bg-white/10 transition-colors duration-500"
            whileHover={{ scale: 1.02 }} data-cursor-hover>+358 40 377 9200</motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default ReservationCTA;
